import { useStore } from '@/store';
import {
  useDeployTemplate,
  useExportTemplate,
  useNavigateAway,
  useSaveState,
  useTestTemplate,
} from '@/hooks';
import { LayoutDirection } from '@/types';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

export const useHeader = () => {
  /* Global State */
  const setLayoutDirection = useStore(({ ui }) => ui.setLayoutDirection);
  /* Hooks */
  const navigate = useNavigate();
  const { handleTestTemplate } = useTestTemplate();
  const { save } = useSaveState();
  const { deployTemplate } = useDeployTemplate();
  const { localExport, localExportUpdate } = useExportTemplate();
  const { requestNavigateToDomain, requestNavigateToTemplate } =
    useNavigateAway();

  const isSavingTemplate = useStore(({ config }) => config.isSavingTemplate);
  const userId = useStore(({ config }) => config.userId);
  const isUpdateDiff = useStore(({ config }) => config.isUpdateDiff);
  const jwt = useStore(({ config }) => config.JWT);

  /**
   * Effects
   */

  useEffect(() => {
    if (!isSavingTemplate) return;
    void handleSaveFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSavingTemplate]);

  /**
   * Handlers
   **/
  const handleSaveFile = async () => {
    const shouldNavigateAfterSave = useStore.getState().config.isSavingTemplate;
    const saved = await save();
    if (saved && shouldNavigateAfterSave) {
      // The token has to survive the trip back too — the setup screen reads
      // both straight off the URL, so dropping it lands there unauthenticated.
      navigate('/');
    }
  };

  const handleExportTemplate = () => {
    if (isUpdateDiff) {
      localExportUpdate();
    } else {
      localExport();
    }
  };

  const handleDeployTemplate = () => {
    deployTemplate();
  };

  const handleConfigureTemplate = () => {
    navigate('configure');
  };

  const setLayoutVertical = () => {
    setLayoutDirection(LayoutDirection.Column);
  };

  const setLayoutHorizontal = () => {
    setLayoutDirection(LayoutDirection.Row);
  };

  const handleNavigateToTemplateSelection = () => {
    requestNavigateToTemplate();
  };

  const handleNavigateToDomainSelection = () => {
    requestNavigateToDomain();
  };

  return {
    handleTestTemplate,
    handleSaveFile,
    handleExportTemplate,
    handleDeployTemplate,
    handleConfigureTemplate,
    setLayoutVertical,
    setLayoutHorizontal,
    handleNavigateToTemplateSelection,
    handleNavigateToDomainSelection,
  };
};
